import React, {useState} from "react";

import logoImg from "../img/header-logo.svg";

import "../style/header.css";

function Header() {
    const [mobMenuOpened, setMobMenuOpened] = useState(false);

    function toggleMobMenu() {
        setMobMenuOpened(!mobMenuOpened);
    }

    return (
        <React.Fragment>
            <header className="header-container">
                <img src={logoImg} alt="" className="logo-header" />
                <nav className="menu-wrapper">
                    <a href="/">Início</a>
                    <a href="/#dest">2KPLAY</a>
                    <a href="/#mobile">2KMÓVEL</a>
                    <a href="/#fix">2KFIXO</a>
                    <a href="/faq">FAQ</a>
                    <a href="/seja-parceiro">Seja parceiro</a>
                </nav>
                <div className="buttons-wrapper">
                    <a href="https://conta.2k20.com.br/login">Login</a>
                    <a href="http://wa.me/+552122000888" target="_blank" rel="noreferrer">Entre em contato</a>
                    <button id="mob-menu-button" onClick={toggleMobMenu}>
                        <svg width="26" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.66667 16.6667H28.3333C29.25 16.6667 30 15.9167 30 15C30 14.0833 29.25 13.3333 28.3333 13.3333H1.66667C0.75 13.3333 0 14.0833 0 15C0 15.9167 0.75 16.6667 1.66667 16.6667ZM1.66667 23.3333H28.3333C29.25 23.3333 30 22.5833 30 21.6667C30 20.75 29.25 20 28.3333 20H1.66667C0.75 20 0 20.75 0 21.6667C0 22.5833 0.75 23.3333 1.66667 23.3333ZM1.66667 10H28.3333C29.25 10 30 9.25 30 8.33333C30 7.41667 29.25 6.66667 28.3333 6.66667H1.66667C0.75 6.66667 0 7.41667 0 8.33333C0 9.25 0.75 10 1.66667 10ZM0 1.66667C0 2.58333 0.75 3.33333 1.66667 3.33333H28.3333C29.25 3.33333 30 2.58333 30 1.66667C30 0.75 29.25 0 28.3333 0H1.66667C0.75 0 0 0.75 0 1.66667Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </header>


            <div className={!mobMenuOpened ? "menu-mobile closed" : "menu-mobile"}>
                <ul className="menu-list-mob">
                    <li className="menu-item"><a href="/">Início</a></li>
                    <li className="menu-item"><a href="/#dest">2KPLAY</a></li>
                    <li className="menu-item"><a href="/#mobile">2KMÓVEL</a></li>
                    <li className="menu-item"><a href="#fix">2KFIXO</a></li>
                    <li className="menu-item"><a href="/faq">FAQ</a></li>
                    <li className="menu-item"><a href="/seja-parceiro">Seja parceiro</a></li>
                </ul>
            </div>
        </React.Fragment>
    )
}

export default Header;